import { render, staticRenderFns } from "./landTotal.vue?vue&type=template&id=32ec3ebe&scoped=true"
import script from "./landTotal.vue?vue&type=script&lang=js"
export * from "./landTotal.vue?vue&type=script&lang=js"
import style0 from "./landTotal.vue?vue&type=style&index=0&id=32ec3ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec3ebe",
  null
  
)

export default component.exports